import { render, staticRenderFns } from "./seedBackCommodity.vue?vue&type=template&id=3f1fa0a8&scoped=true"
import script from "./seedBackCommodity.vue?vue&type=script&lang=js"
export * from "./seedBackCommodity.vue?vue&type=script&lang=js"
import style0 from "./seedBackCommodity.vue?vue&type=style&index=0&id=3f1fa0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1fa0a8",
  null
  
)

export default component.exports